module.exports = __webpack_public_path__ + "static/media/elegant_sms.be99a22a.mp3";